import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga4';
import './styles/index.css';
import App from './components/App.js';
import registerServiceWorker from './registerServiceWorker';

ReactGA.initialize('UA-7627770');
ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();

